const server =
  import.meta.env.MODE === 'development'
    ? 'http://localhost:3000'
    : 'https://authentication-api.app.kinesis.org';

export { server };
